type WalletPaymentIntentAddonPriceIdsInput = {
  isChallengePackageFlow: boolean;
  isPersonalCoachingAdded?: boolean;
  personalCoachPriceId?: string | null;
  isNutritionCoachingAdded?: boolean;
  nutritionCoachingPriceId?: string | null;
  isSupplementAdded?: boolean;
  supplementPackPriceId?: string | null;
};

type WalletPaymentIntentKeyInput = {
  priceId: string;
  addonPriceIds: string[];
  couponId?: string | null;
  claimGift: boolean;
};

type WalletPaymentIntentResponseCurrentInput = {
  responseIntentKey: string;
  desiredIntentKey?: string | null;
};

export const buildWalletPaymentIntentAddonPriceIds = ({
  isChallengePackageFlow,
  isPersonalCoachingAdded,
  personalCoachPriceId,
  isSupplementAdded,
  supplementPackPriceId,
}: WalletPaymentIntentAddonPriceIdsInput): string[] => {
  const addonPriceIds: string[] = [];

  if (
    isChallengePackageFlow &&
    isPersonalCoachingAdded &&
    personalCoachPriceId
  ) {
    addonPriceIds.push(personalCoachPriceId);
  }

  if (!isChallengePackageFlow && isSupplementAdded && supplementPackPriceId) {
    addonPriceIds.push(supplementPackPriceId);
  }

  return addonPriceIds;
};

export const buildWalletPaymentIntentKey = ({
  priceId,
  addonPriceIds,
  couponId,
  claimGift,
}: WalletPaymentIntentKeyInput): string => {
  return `${priceId}-${addonPriceIds.join(',')}-${couponId ?? ''}-${
    claimGift ? '1' : '0'
  }`;
};

export const isWalletPaymentIntentResponseCurrent = ({
  responseIntentKey,
  desiredIntentKey,
}: WalletPaymentIntentResponseCurrentInput): boolean => {
  return responseIntentKey === desiredIntentKey;
};
